import styled from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'

const StyledSegmentedRoot = styled.div`
  display: flex;
`

const StyledSegmentedList = styled.div`
  flex-shrink: 0;
  display: flex;
  background-color: ${colorsOptions.greys['grey-20']};
  border-radius: 48px;
  align-items: center;
  padding: 0 2px;
  width: 100%;
`

const StyledSegmentedTrigger = styled.button`
  all: unset;
  box-sizing: border-box;
  outline: none;
  word-break: normal;
  width: 100%;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}


  background-color: inherit;
  padding: 0 1rem;
  height: 40px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colorsOptions.greys['grey-100']};
  stroke: ${colorsOptions.greys['grey-100']};
  user-select: none;

  &:first-child {
    border-top-left-radius: 48px;
    border-bottom-left-radius: 48px;
  }

  &:last-child {
    border-top-right-radius: 48px;
    border-bottom-right-radius: 48px;
  }

  &[data-state='active'] {
    height: 36px;
    ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
    background-color: ${colorsOptions.greys.white};
    border-radius: 48px;
    box-shadow: 0px 3px 1px 0px #141a210a;
    box-shadow: 0px 3px 8px 0px #141a211f;
  }
`

const StyledSegmentedContent = styled.div`
  all: unset;
  flex-grow: 1;
  padding: 1rem;
  background-color: white;
  outline: none;
`

const StyledSegmentedSeparator = styled.div`
  all: unset;
  width: 1px;
  height: 20.57px;
  background-color: ${colorsOptions.greys['grey-40']};
`

const StyledSegmentedSkeleton = styled.div`
  border-radius: 48px;
  background-color: ${colorsOptions.greys['grey-30']};
  color: ${colorsOptions.greys['grey-30']};
`

export {
  StyledSegmentedContent,
  StyledSegmentedList,
  StyledSegmentedRoot,
  StyledSegmentedTrigger,
  StyledSegmentedSeparator,
  StyledSegmentedSkeleton
}
